






















































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import City from '@/components/City/index.vue'

@Component({
  name: 'Sort',
  components: {
    City
  }
})
export default class Sort extends Vue {
  /**
   * @param {Number} value id
   * @description: 默认-99全部
   */
  @Prop({
    type: [Number],
    default: -99
  }) value!: number

   @Prop({
     type: Boolean,
     default: false
   }) loading!: boolean

  /**
   * @param {Number} type 筛选类型
   * @description: 默认1:地区、产品类型、排序，2:销量、佣金
   */
  @Prop({
    type: Number,
    default: 1
  })
  type!: number;

  /**
   * @param {Number, String} area 地区id
   * @description: 默认空
   */
  @Prop({
    type: [String, Number],
    default: ''
  }) area!: string | number

  // 城市列表选中的值
  private cityName = '';

  // 排序
  private sort = 1;

  // 港澳和海外的地区
  private areaId = 0;

  // 产品类目数据
  private options = [
    { value: -99, label: '全部' },
    { value: 0, label: '门票' },
    { value: 12, label: '抢购' },
    { value: 3, label: '日游' },
    // { value: 11, label: '商品' },
    { value: 1, label: '套餐' },
    { value: 5, label: '住宿' }
  ];

  // 排序数据
  private sortOptions = [
    { value: 1, label: '推荐值' },
    { value: 2, label: '最早发布' },
    { value: 3, label: '最近发布' },
    { value: 4, label: '销量从高到低' },
    { value: 5, label: '销量从低到高' },
    { value: 6, label: '佣金从高到低' },
    { value: 7, label: '佣金从低到高' }
  ];

  // 港澳地区数据
  private cityList = [
    { value: 0, label: '香港', id: 10072 },
    { value: 1, label: '澳门', id: 10073 }
  ];

  // 海外地区数据
  private overseasList = [
    { value: 0, label: '泰国', id: 810 },
    { value: 1, label: '新加坡', id: 809 },
    { value: 2, label: '马来西亚', id: 808 }
  ];

  get areaList () {
    return this.type === 5 ? this.cityList : this.overseasList
  }

  // 更新v-model
  @Emit()
  input<T> (name: T): T {
    return name
  }

  @Watch('type')
  setSort (): void {
    if (this.type === 3) {
      this.sort = 3
    }
    this.areaId = 0
  }

  @Watch('area')
  setArea (): void {
    // 港澳设置默认地区
    if ([5, 6].includes(this.type)) {
      const item = this.areaList.find(item => item.id === Number(this.area))
      if (item) {
        this.areaId = item.value
      }
    }
  }

  // 产品类目
  get activeTreeId (): number {
    return this.value
  }

  set activeTreeId (newData: number) {
    this.input(newData)
  }

  // 切换城市
  @Emit('change:city')
  changeCity (item: any): number {
    this.cityName = item.areaName
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.$refs.popover.showPopper = false
    return item.areaId
  }

  // 切换类目
  @Emit('change:treeId')
  changeTreeId (): number {
    return this.activeTreeId
  }

  // 切换排序
  @Emit('change:sort')
  changeSort (): { sort: number; sortType: number } {
    const sortMap: Record<number, { sort: number; sortType: number }> = {
      1: { sort: 1, sortType: 1 }, // 推荐值降序
      2: { sort: 3, sortType: 0 }, // 发布时间升序
      3: { sort: 3, sortType: 1 }, // 发布时间降序
      4: { sort: 2, sortType: 1 }, // 销量降序
      5: { sort: 2, sortType: 0 }, // 销量升序
      6: { sort: 4, sortType: 1 }, // 利润降序
      7: { sort: 4, sortType: 0 } // 利润升序
    }
    return sortMap[this.sort]
  }

  // 港澳和海外改变地区选择
  @Emit('change:city')
  changeAreaId (index: number) {
    const item = this.areaList[index]
    return item.id
  }
}
